export class EnvironmentConstants {
  static PRODUCTION = "prod";
  static HOMOLOG = "homolog";
  static DEV = "dev";
}
